import { Reveal } from "./Reveal";
import LeadForm from "./LeadForm";

export default function FinalCTA() {
  return (
    <section data-testid="final-cta-banner" className="bg-gradient-to-r from-[#4B2A9E] to-[#1B2FD8] px-4 sm:px-8 lg:px-12 py-14 sm:py-20 lg:py-28 relative overflow-hidden">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-8 lg:gap-12 items-center relative z-10">
        <Reveal>
          <h2 className="font-display font-extrabold tracking-tight text-4xl sm:text-5xl lg:text-6xl text-[#FFFFFF] leading-[1.02]">
            BACK TO <span className="italic text-[#C9C2FF]">YOU</span>
          </h2>
          <p className="mt-6 font-display font-bold text-[#FFFFFF]/90 text-lg sm:text-xl tracking-wide">
            TRY THIS BEFORE YOU COMMIT TO ANOTHER CALORIE DEFICIT AND MORE CARDIO.
          </p>
          <p className="mt-6 text-sm sm:text-base font-semibold uppercase tracking-[0.2em] text-[#A89DE3]">
            FREE 14-DAY METABOLIC RESET | SEPTEMBER 28 - OCTOBER 11
          </p>
          <p className="mt-3 font-display font-extrabold text-[#FFFFFF] text-xl tracking-tight">
            RESET YOUR METABOLISM. EAT MORE. EXERCISE LESS.
          </p>
          <p className="mt-6 text-xs sm:text-sm text-[#A89DE3] leading-relaxed max-w-md">
            CHALLENGE FEE: $0 | GROCERIES + REQUIRED FOUNDATIONAL SUPPLEMENTS ARE YOUR RESPONSIBILITY.
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="bg-[#0B0B12] rounded-3xl border border-[#A89DE3]/20 p-5 sm:p-10 shadow-2xl shadow-black/30">
            <h3 className="font-display font-extrabold text-[#FFFFFF] text-2xl sm:text-3xl tracking-tight mb-6">
              READY TO GET BACK TO YOU?
            </h3>
            <LeadForm idPrefix="footer-form" dark />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
